import { render, staticRenderFns } from "./banner-y-3.vue?vue&type=template&id=71fb82ee"
import script from "./banner-y-3.vue?vue&type=script&lang=js"
export * from "./banner-y-3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports